module.exports = __webpack_public_path__ + "static/media/microbit-front.7138e25e.gif";